// extracted by mini-css-extract-plugin
module.exports = {"detail":"actPlaceRule_detail_14XOd","box":"actPlaceRule_box_1mC92","title":"actPlaceRule_title_1Tfri","time":"actPlaceRule_time_1Atmh","content":"actPlaceRule_content_1PzEr"};